import { SelectItem } from 'primeng/api';

export class DropdownItem<T = string> implements SelectItem {
  label: string;
  value: T;
  title?: string;
  constructor(label: string, value: T, title: string = '') {
    this.label = label;
    this.value = value;
    this.title = title;
  }
}
